import Wechat from "../../common/utils/wechat"
import cookies from "../../common/utils/cookies"

import * as Sentry from "@sentry/browser"
import * as userApi from "../../common/api/user"
import localStorage from "../../common/utils/localStorage"
import * as report from "../../common/utils/report"
import * as request from "../../common/utils/request"

function getLoginState(userAgent) {
  return new Promise((resolve, reject) => {
    let loginState
    if (userAgent.weixin) {
      let wechat = new Wechat({
        getDetail: 1
      })
      if (wechat.init()) {
        wechat.getOpenid({
          onSuccess: function() {
            loginState = {
              openid: this.openid,
              openkey: this.accessToken,
              session_id: "hy_gameid",
              session_type: "wc_actoken",
              wx_appid: "wx951bdcac522929b6",
              accountType: "wechat"
            }
            if (this.info.headimgurl) {
              loginState.avatar = this.info.headimgurl.replace(/https?/, "https")
            } else {
              loginState.avatar = "//midas.gtimg.cn/store_config/1585207867985EI153zif.png"
            }
            if (this.info.nickname) {
              loginState.nickname = this.info.nickname
            }
            resolve(loginState)
          },
          onError: () => {
            reject()
          }
        })
      } else {
        reject()
      }
    } else if (userAgent.QQ) {
      loginState = {
        openid: cookies.get("uin").substr(1) * 1,
        openkey: cookies.get("skey"),
        session_id: "uin",
        session_type: "skey",
        accountType: "qq"
      }

      loginState.avatar = `//q.qlogo.cn/g?b=qq&nk=${loginState.openid}&s=100`
      resolve(loginState)
    } else if (window._msdkLoginParams && userAgent.msdk) {
      if (_msdkLoginParams.acctype === "wx" || _msdkLoginParams.acctype === "weixin") {
        loginState = {
          openid: _msdkLoginParams.openid,
          openkey: _msdkLoginParams.access_token,
          session_id: "hy_gameid",
          session_type: "wc_actoken",
          wx_appid: _msdkLoginParams.appid,
          accountType: "wechat"
        }
        // dispatch("getWechatNicknameAndAvatar")
        resolve(loginState)
      } else if (_msdkLoginParams.acctype === "qq") {
        /**
           *  {
    "acctype": "qq",
    "appid": "1104922185",
    "openid": "4C5782CCFEF74AE493A71B526C43DDC1",
    "access_token": "E51744B676BDABA33EF0E9160609E279",
    "pay_token": "45DD6BF183D747520BCF974977835EFF",
    "platid": "0"
   }
           */
        loginState = {
          openid: _msdkLoginParams.openid,
          openkey: _msdkLoginParams.access_token,
          session_id: "openid",
          session_type: "kp_accesstoken",
          qq_appid: _msdkLoginParams.appid,
          accountType: "qq"
        }

        resolve(loginState)
      } else {
        reject("无登陆态")
      }
    } else {
      reject("无登陆态")
    }
  }).then(loginState => {
    Sentry.configureScope(scope => {
      scope.setUser({ id: loginState.openid, ...loginState })
    })
    return loginState
  })
  // .catch(res => {
  //   Raven.captureException(new Error("get-login-state-error"), {
  //     tags: { type: "get-login-state-error" },
  //     extra: {
  //       res,
  //       state
  //     }
  //   })
  //
  //   throw res
  // })
}

function getMobileZoneInfo({ loginState, userAgent, offerId }) {
  const params = {
    openid: loginState.openid,
    openkey: loginState.openkey,
    sessionId: loginState.session_id,
    sessionType: loginState.session_type,
    wxAppid2: loginState.wx_appid,
    offerId: offerId,
    // sandbox: getters.sandbox,
    clientVersion: userAgent.iOS ? "iap" : "android"
  }
  return userApi.getMobileZones(params).then(res => {
    return res.zone_list
  })
}

export function getWzryZones({ userAgent, loginState }) {
  return request.getScript("//game.gtimg.cn/comm-htdocs/js/game_area/utf8verson/yxzj_server_select_utf8.js").then(() => {
    return window.YXZJServerSelect.STD_DATA.filter(item => {
      let sys, account
      if (loginState.accountType == "wechat") {
        account = "weixin"
      } else if (loginState.accountType == "qq") {
        account = "qq"
      }

      if (userAgent.iOS) {
        sys = "ios"
      } else if (userAgent.android) {
        sys = "android"
      }
      return item.sk == sys && item.ck == account
    }).map(item => ({ zone_id: item.v, zone_name: item.t }))
  })
}

function getUserRecommendZone({ loginState, offerId, userAgent }) {
  return userApi.getUserRecommend({
    openid: loginState.openid,
    openkey: loginState.openkey,
    sessionId: loginState.session_id,
    sessionType: loginState.session_type,
    wxAppid2: loginState.wx_appid,
    offerId: offerId,
    // sandbox: sandbox,
    model: userAgent.iOS ? "wzry_partition_ios_recomm" : "wzry_partition_android_recomm",
    ext: ""
  })
}

async function getUserZoneId({ loginState, offerId, userAgent }) {
  let userZoneid
  if (userAgent.msdk) {
    const searchParams = new URLSearchParams(location.search)
    userZoneid = searchParams.get("partition")
  } else {
    const defaultSelectedZone = localStorage.get(`wzry_activity_${offerId}_${loginState.openid}_${userAgent.weixin ? "wx" : "qq"}`, true)
    if (defaultSelectedZone) {
      userZoneid = defaultSelectedZone.zone_id
    } else {
      const recommendZone = await getUserRecommendZone({ loginState, offerId, userAgent })
      if (recommendZone.recomm_info && recommendZone.recomm_info.part) {
        userZoneid = recommendZone.recomm_info.part
      } else {
        throw new Error("no zoneid")
      }
    }
  }
  return userZoneid
}

function getRoleInfo({ loginState, offerId, userAgent, zoneid }) {
  let params = {
    openid: loginState.openid,
    openkey: loginState.openkey,
    sessionId: loginState.session_id,
    sessionType: loginState.session_type,
    wxAppid2: loginState.wx_appid,
    offerId: offerId,
    // sandbox: sandbox,
    clientVersion: userAgent.iOS ? "iap" : "android",
    zoneid
  }
  return userApi
    .getMobileRoleInfo(params)
    .then(res => {
      let roles = res.role_info,
        rolesArr = []
      roles.forEach(item => {
        if (item) {
          rolesArr.push({ name: decodeURIComponent(item.role_name), id: item.role_id })
        }
      })
      if (rolesArr.length == 0) {
        throw new Error("你在此区无游戏角色")
      } else {
        return {
          roleInfo: rolesArr[0],
          partitionInfo: res.partition_info
        }
      }
    })
    .catch(res => {
      if (res.ret == 1220) {
        throw new Error("你在此区无游戏角色")
      } else {
        throw new Error(res.msg || "查询角色系统繁忙，请稍候再试！")
      }
    })
}

function getOpenlink({ offerId, sandbox, url }) {
  return userApi.getOpenlink(
    {
      offerId,
      sandbox
    },
    {
      url
    }
  )
}
function reportUserAction({ loginState, resultInfo, iformat, pf, offerId }) {
  let data = {
    3: loginState.openid,
    8: JSON.stringify(resultInfo || ""),
    // 19: getters.currentItem && getters.currentItem.code,
    13: 1,
    21: iformat,
    26: `vip_m-${pf || "pay_html5"}_-html5`,
    24: offerId,
    37: loginState.session_id,
    43: loginState.session_type,
    41: "wx951bdcac522929b6",
    50: navigator.userAgent,
    // 51: getters.aid,
    36: location.href
  }

  report.dataReport(data)
}

function jumpToQQ(url) {
  userApi.jumpToMqq(url)
}

function setOnShareHandler({ userAgent, shareInfo, url = location.href }) {
  let params = {
    wxAppid2: "wx951bdcac522929b6",
    img: shareInfo.ICON,
    title: shareInfo.TITLE,
    desc: shareInfo.DESC,
    url
  }
  if (userAgent.QQ) {
    userApi.setOnMqqShareHandler(params)
  } else if (userAgent.weixinminiprogram) {
    wx.miniProgram.postMessage({
      data: {
        title: shareInfo.TITLE,
        imageUrl: shareInfo.MINIPROGRAM_ICON,
        path: url
      }
    })
  } else if (userAgent.weixin) {
    userApi.setOnWechatShareHandler(params)
  }
}

function getUserInfoInGame({ loginState, sandbox, offerId, gameid, game_platform_id }) {
  return userApi
    .followActivity(
      {
        sandbox,
        offerId
      },
      {
        ...loginState,
        action: "query_wz_nick_img",
        gameid,
        game_platform_id
      }
    )
    .then(res => {
      const val = res?.info?.user_nick_img
      const userInfo = {}
      for (let key of Object.keys(val)) {
        userInfo.avatar = decodeURIComponent(val[key].head_img.replace(/https?/gi, "https"))
        userInfo.nickname = decodeURIComponent(val[key].role_name)
      }
      return userInfo
    })
}

export {
  getLoginState,
  getMobileZoneInfo,
  getUserRecommendZone,
  getUserZoneId,
  getRoleInfo,
  getOpenlink,
  reportUserAction,
  jumpToQQ,
  setOnShareHandler,
  getUserInfoInGame
}
